// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { DateShortcut } from '@/components/form-date-picker';
import { DateTime } from 'luxon';

function today(): DateTime {
  return DateTime.now().startOf('day');
}

export const PROJECT_LINE_ITEM_DATE_SHORTCUTS: DateShortcut[] = [
  {
    label: 'Today',
    getValue: () => today(),
  },
  {
    label: 'Beginning of this week',
    getValue: () => today().startOf('week'),
  },
  {
    label: 'Beginning of last month',
    getValue: () => today().minus({ months: 1 }).startOf('month'),
  },
  {
    label: 'End of last month',
    getValue: () => today().minus({ months: 1 }).endOf('month').startOf('day'),
  },
  {
    label: 'Beginning of this month',
    getValue: () => today().startOf('month'),
  },
  {
    label: 'End of this month',
    getValue: () => today().endOf('month').startOf('day'),
  },
  {
    label: 'Beginning of next month',
    getValue: () => today().plus({ months: 1 }).startOf('month'),
  },
  {
    label: 'End of next month',
    getValue: () => today().plus({ months: 1 }).endOf('month').startOf('day'),
  },
  {
    label: 'Beginning of this quarter',
    getValue: () => today().startOf('quarter'),
  },
  {
    label: 'End of this quarter',
    getValue: () => today().endOf('quarter').startOf('day'),
  },
];
